import { useHostServices } from '../HostServices'

interface Auth {
  cif: string | undefined
  guid: string | undefined
  apigeeToken: ApigeeToken
  tokenFailure: boolean
}

type ApigeeToken = {
  access_token: string | null | undefined // eslint-disable-line camelcase
  token_type: string // eslint-disable-line camelcase
}

/* istanbul ignore next */
export const useApiAuth = (): Auth => {
  const { session } = useHostServices()

  return {
    cif: session.data?.cif,
    guid: session.data?.guid,
    apigeeToken: {
      token_type: 'Bearer',
      access_token: session.data?.access_token,
    },
    tokenFailure: false,
  }
}
